module.exports = __webpack_public_path__ + "img/54.bd269305.webp";